module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "booker"
  }, [_c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expiry),
      expression: "expiry"
    }],
    staticClass: "exp-timer"
  }, [_c('el-col', {
    attrs: {
      "span": "24"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.formatExpiry) + "\n    ")])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "lg": {
        span: 18
      },
      "md": {
        span: 18
      },
      "sm": {
        span: 18
      },
      "xs": {
        span: 24
      }
    }
  }, [(_vm.showPaymentArea) ? _c('div', [_c('paymentform', {
    attrs: {
      "customer": _vm.stripeCustomer
    },
    on: {
      "recheck": _vm.checkCustomer,
      "confirm": _vm.onPaymentConfirm,
      "cancel": _vm.onPaymentCancel
    }
  })], 1) : (_vm.showLargeLogin) ? _c('div', [_c('largelogin')], 1) : (_vm.showSuccessScreen) ? _c('div', [_c('successscreen', {
    attrs: {
      "bookingData": _vm.bookingDataCopy
    }
  })], 1) : _c('div', [_c('selectionform', {
    attrs: {
      "bookingData": _vm.bookingData
    },
    on: {
      "type": _vm.onTypeSelected,
      "site": _vm.onSiteSelected,
      "duration": _vm.onDurationSelected,
      "scene": _vm.onSceneSelected,
      "date": _vm.onDateSelected,
      "time": _vm.onTimeSelected
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": {
        span: 6
      },
      "md": {
        span: 6
      },
      "sm": {
        span: 6
      },
      "xs": {
        span: 24
      }
    }
  }, [_c('div', {
    staticClass: "panelheader border-blue"
  }, [_c('div', {
    staticClass: "booker-title"
  }, [_vm._v("Booking Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('ul', {
    staticStyle: {
      "list-style": "none",
      "padding-left": "10pt"
    }
  }, _vm._l((_vm.bookingData), function(value, key) {
    return _c('li', {
      key: key
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold",
        "float": "left",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(value.name || value))]), _vm._v(" "), _c('br')])
  })), _vm._v(" "), _c('el-popover', {
    ref: "processError",
    attrs: {
      "placement": "bottom",
      "title": "Error",
      "width": "200",
      "trigger": "manual",
      "value": !_vm.dataIsValid,
      "content": _vm.popoverContent
    }
  }), _vm._v(" "), (_vm.showSuccessScreen) ? _c('el-button', {
    staticClass: "sum-button",
    attrs: {
      "type": "save"
    },
    on: {
      "click": _vm.newBooking
    }
  }, [_vm._v("\n          New Booking\n        ")]) : _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:processError",
      arg: "processError"
    }],
    staticClass: "sum-button",
    attrs: {
      "type": "save"
    },
    on: {
      "click": _vm.processBooking
    }
  }, [_vm._v("\n          " + _vm._s(_vm.sumButtonLabel) + "\n        ")])], 1)]), _vm._v(" "), (!_vm.userAuthenticated && !_vm.showLargeLogin) ? _c('div', [_c('el-col', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "lg": {
        span: 6
      },
      "md": {
        span: 6
      },
      "sm": {
        span: 6
      },
      "xs": {
        span: 24
      }
    }
  }, [_c('div', {
    staticClass: "panelheader border-yellow"
  }, [_c('div', {
    staticClass: "booker-title"
  }, [_vm._v("Login")])]), _vm._v(" "), _c('div', {
    staticClass: "body log-wrapper"
  }, [_c('loginform')], 1)])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11f2ec5d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booker/Booker.vue
// module id = 887
// module chunks = 2